import React from 'react';
import {Image, Button} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

import constants from '@constants';
import {Layouts, Card} from '@components';
import {Props} from './types';

import {MAN, WOMEN, FAMILY} from './../../../assets/images';

import './index.scss';
import paths from '@paths';

const Landing: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  return (
    <div className="a__landing">
      <div className="b__landing-top">
        <div className="w__waving">
          <Image src={constants.IMAGES.WAVING} />
        </div>
        <div className="w__hero-main">
          <div className="w__introduction">
            <div className="w__message">
              <div className="b__message-main">
                <h1 className="message-text">災害発生時でも</h1>
                <h1 className="message-text">タップするだけで</h1>
                <h1 className="message-text">安否報告できる</h1>
              </div>
              <div className="b__message-sub">
                <span className="sub-text">AnpiCheckerなら</span>
                <span className="sub-text">タップで質問に答えるだけで</span>
                <span className="sub-text">管理者に安否報告できます。</span>
              </div>
              {isAuthed ? (
                <div className="w__main-button">
                  <Button
                    className="b__main-button"
                    onClick={() => props.history.push(paths.dashboard.main)}
                  >
                    <span className="button-text">ダッシュボードに移動</span>
                  </Button>
                </div>
              ) : (
                <div className="w__main-button">
                  <Button
                    className="b__main-button"
                    onClick={() => props.history.push(paths.signIn.main)}
                  >
                    <span className="button-text">ログイン・新規登録</span>
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="w__images">
            <div className="w__phone-image">
              <Image src={constants.IMAGES.MOBILE} className="b__phone-image" />
            </div>
            <div className="w__laptop-image">
              <Image
                src={constants.IMAGES.LAPTOP}
                className="b__laptop-image"
              />
            </div>
          </div>
        </div>

        <div className="w__fan">
          <Image src={constants.IMAGES.FAN_SHAPE} />
        </div>
      </div>
      <div className="b__description">
        <div className="w__description-title">
          <span className="title-text">AnpiCheckerとは？</span>
        </div>
        <div className="w__description-message">
          <span className="description-text">
            AnpiCheckerは災害発生時に安否確認の自動一斉送信を行い、
          </span>
          <span className="description-text">
            あなたの大切な人の安否を一覧ですぐに確認できるサービスです。
          </span>
          <span className="description-text">
            ユーザー登録を行うだけで、どなたでもお気軽に使用できます。
          </span>
        </div>
        <div className="w__flow-images">
          <div className="b__flow">
            <div className="w__circle">
              <div className="b__circle-icon">
                <Image src={constants.IMAGES.BUILDING} />
              </div>
              <div className="w__flow-description">
                <span className="description-text">災害発生</span>
              </div>
            </div>
            <div className="b__arrow-icon">
              <Image src={constants.IMAGES.ARROW_RIGHT} />
            </div>
          </div>
          <div className="b__flow">
            <div className="w__circle">
              <div className="b__circle-icon">
                <Image src={constants.IMAGES.MAIL} />
              </div>
              <div className="w__flow-description">
                <span className="description-text">
                  安否確認メール
                  <br />
                  自動一斉送信
                </span>
              </div>
            </div>
            <div className="b__arrow-icon">
              <Image src={constants.IMAGES.ARROW_RIGHT} />
            </div>
          </div>
          <div className="b__flow">
            <div className="w__circle">
              <div className="b__circle-icon">
                <Image src={constants.IMAGES.PERSON} />
              </div>
              <div className="w__flow-description center">
                <span className="description-text">安否状況報告</span>
              </div>
            </div>
          </div>
        </div>
        <div className="w__reason">
          <Button
            className="b__reason-button"
            onClick={() => props.history.push(paths.reason.main)}
          >
            <div className="button-text">AnpiCheckerに込められた想いとは？</div>
          </Button>
        </div>
        <div className="w__recommended">
          <div className="b__recommended-title">
            <span className="title-text">こんな方にオススメです</span>
          </div>
          <div className="w__cards">
            <div className="b__recommended-card">
              <div className="b__recommended-image">
                <Image src={MAN} />
              </div>
              <div className="w__recommended-messages">
                <div className="w__message-header">
                  <span>
                    災害発生時に従業員の安否を確認したいけれど、利用料金が高くて断念した人
                  </span>
                </div>
                <div className="w__message-area">
                  <div className="b__check-icon">
                    <Image src={constants.IMAGES.CHECK} />
                  </div>
                  <div className="w__message-text">
                    <span>
                      AnpiCheckerは<span className="bold-text">月額0円</span>
                      で
                      <br />
                      最大1000人まで登録でき
                      <br className="br-line" />
                      ます。
                      <br />
                      <span className="notes">※無料プランの場合</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="b__recommended-card center">
              <div className="b__recommended-image">
                <Image src={FAMILY} />
              </div>
              <div className="w__recommended-messages">
                <div className="w__message-header center">
                  <span>
                    災害発生時、大切な家族の安否をリアルタイムで確認したい人
                  </span>
                </div>
                <div className="w__message-area">
                  <div className="b__check-icon">
                    <Image src={constants.IMAGES.CHECK} />
                  </div>
                  <div className="w__message-text">
                    <span>
                      AnpiCheckerは最新の安否
                      <br />
                      状況を
                      <span className="bold-text">24時間</span>
                      いつでも
                      <br />
                      ご確認頂けます。
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="b__recommended-card">
              <div className="b__recommended-image">
                <Image src={WOMEN} />
              </div>
              <div className="w__recommended-messages">
                <div className="w__message-header">
                  <span>
                    パソコン・スマートフォンに詳しくない、導入したくても実際に使えるか不安な人
                  </span>
                </div>
                <div className="w__message-area">
                  <div className="b__check-icon">
                    <Image src={constants.IMAGES.CHECK} />
                  </div>
                  <div className="w__message-text">
                    <span>
                      AnpiCheckerは
                      <span className="bold-text">
                        シンプルな機能で
                        <br />
                        簡単に
                      </span>
                      安否状況を確認するこ
                      <br />
                      とが可能です。
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w__options">
          <div className="w__options-title">
            <span>
              AnpiCheckerなら
              <br />
              初期費用は一切かかりません
              <br />
              <span className="emphasize">月額0円から利用できます</span>
            </span>
          </div>
          <div className="top-planbox">
            <div className="w__price-cards">
              <Card.Price
                option={constants.PLAN.FREE}
                history={props.history}
                me={props.me}
              />
              <Card.Price
                option={constants.PLAN.SAFETY}
                className="center"
                history={props.history}
                me={props.me}
              />
              <Card.Price
                option={constants.PLAN.SAFETY_X}
                history={props.history}
                me={props.me}
              />
            </div>
          </div>
        </div>
        <div className="w__help">
          <div className="b__help-title">
            <span>よくある質問</span>
          </div>
          {constants.HELPS.qAndA.slice(0, 3).map((help: any, index: number) => {
            return (
              <div key={index}>
                <div className="b__help-item">
                  <div className="b__item-question">
                    <span>{help.question}</span>
                  </div>
                  <div className="b__help-divier" />
                  <div className="b__item-answer">
                    <span c__item-answer>{help.answer}</span>
                  </div>
                  <div className="b__item-answer">
                    <span c__item-answer>{help.answer1}</span>
                    <ul>
                      {help.lists1 && (
                        <ul>
                          {help.lists1.map((lists: any, index: number) => {
                            return <li key={index}>{lists.process}</li>;
                          })}
                        </ul>
                      )}
                    </ul>
                  </div>
                  <div className="b__item-answer">
                    <span c__item-answer>{help.answer2}</span>
                    <ul>
                      {help.lists2 && (
                        <ul>
                          {help.lists2.map((lists: any, index: number) => {
                            return <li key={index}>{lists.process}</li>;
                          })}
                        </ul>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="w__more-help">
            <Link to={paths.questions.main} className="b__link-help">
              よくある質問をもっと見る
            </Link>
          </div>
          <div className="w__contact">
            <Button
              className="b__contact-button"
              onClick={() => props.history.push(paths.contact.main)}
            >
              <div className="button-text">お問い合わせはこちら</div>
            </Button>
          </div>
        </div>
        {!isAuthed && <Layouts.Footer.Main />}
      </div>
    </div>
  );
};

export default Landing;
